import {FieldArray, Formik} from 'formik';
import {useHistory} from 'react-router-dom'
import s from './docs.module.css'
import SaveStatus from '../../UIComponents/SaveStatus'
import {Button, TextField, Typography} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Paper from '@mui/material/Paper';
import DatePicker from '../../UIComponents/DatePicker'
/**добавить заказ-наряд для этих работ*/

import DirectorySelect from '../../UIComponents/DirecttorySelect'
import {memo} from "react";


const DocumentSheduleEditor = (props) => {
  const {
    variant = 'view',
    saver = () => { },
    clearer = () => { },
    rights,
    fields,
    postSaveAction=()=>{},
    addingDocument,
    savingDocument,
  } = props

  const ro = variant === 'view'

  const history = useHistory()

  let title = 'Просмотр';
  if (variant === 'edit') {
    title = 'Редактирование';
  } else if (variant === 'add') {
    title = 'Добавление';
  }

  const onCancel = () => {
    history.push('/document/schedule')
  }
  const createWorkOrder = (plan, work) => {
    clearer();
    history.push(`/document/work-order/add/${plan}/${work}`)
    ///document/work-order/add/:sheduleId/:workId
  }

  const handleNumberChange = (event, handleChange, setFieldValue) => {
    const { name, value } = event.target;
    // Удаляем все нецифровые символы из значения
    const cleanedValue = value.replace(/\D/g, '');
    setFieldValue(name, cleanedValue);
  };

  return (
    <div className={s.docsContainer} style={{ width: "100%" }}>
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          <Typography variant='h6'>{title}</Typography>
        </div>
      </div>
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          <Formik
            initialValues={fields}
            onSubmit={saver}
          >
            {({ values, handleSubmit, handleChange, setFieldValue }) => (

              <form onSubmit={handleSubmit}>
                <DirectorySelect
                  name="company"
                  disabled={values?.isView}
                  value={values?.company}
                  onChange={v => setFieldValue('company', v)}
                  label="Компания"
                  dirName="companies"
                />
                <Typography variant="caption">
                  Номер
                </Typography>
                <TextField
                  name="number"
                  disabled={values?.isView}
                  value={values?.number}
                  onChange={handleChange}
                  size='small'
                  fullWidth
                />
                <Typography variant="caption">
                  Дата документа
                </Typography>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    name="date"
                    disabled={values?.isView}
                    value={values?.date}
                    onChange={v => setFieldValue('date', v?.valueOf())}
                    size='small'
                    fullWidth
                    variant="outlined"
                  />
                </div>
                <DirectorySelect
                  name="project"
                  disabled={values?.isView}
                  value={values?.project}
                  onChange={v => setFieldValue('project', v)}
                  label="Проект"
                  dirName="projects"
                />
                <Typography variant="caption">
                  Статус
                </Typography>
                <TextField
                  name="demoStatus"
                  disabled
                  value={values?.demoStatus}
                  onChange={handleChange}
                  size='small'
                  fullWidth
                />
                <Typography variant="caption">
                  Период с
                </Typography>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    name="periodFrom"
                    disabled={values?.isView}
                    value={values?.periodFrom}
                    onChange={v => setFieldValue('periodFrom', v?.valueOf())}
                    size='small'
                    fullWidth
                    variant="outlined"
                  />
                </div>
                <Typography variant="caption">
                  По
                </Typography>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    name="periodTo"
                    disabled={values?.isView}
                    value={values?.periodTo}
                    onChange={v => setFieldValue('periodTo', v?.valueOf())}
                    size='small'
                    fullWidth
                    variant="outlined"
                  />
                </div>
                <Typography variant="caption">
                  Подготовил
                </Typography>
                <TextField
                  name="prepared_by"
                  disabled
                  value={values?.prepared_by}
                  onChange={handleChange}
                  size='small'
                  fullWidth
                />
                <FormControlLabel
                  label="Проведен"
                  control={<Checkbox disabled={values?.isView} name="carried_out" checked={values?.carried_out} onChange={handleChange} />}
                />
                <div style={{ width: "100%", marginBottom: "10px" }}>
                  <FieldArray
                    name='dataArr'
                    validateOnChange={false}
                    render={({ push, remove }) => (
                      <>
                        <TableContainer component={Paper}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Номер</TableCell>
                              <TableCell>Тип работ</TableCell>
                              <TableCell>Количество</TableCell>
                              <TableCell>Начало</TableCell>
                              <TableCell>Окончание</TableCell>
                              <TableCell>Требования к процессу</TableCell>
                              <TableCell>Требования к результату</TableCell>
                              <TableCell>Действия</TableCell>
                            </TableRow>
                          </TableHead>
                          {(values?.dataArr && values?.dataArr?.length > 0) ? (
                            values.dataArr.map((item, index) => {
                              const {
                                id,
                                number,
                                plan,
                                workType,
                                scope,
                                start,
                                end,
                                processRequirements,
                                resultRequirements,
                              } = item;

                              return (
                                <TableRow>
                                  <TableCell>
                                    <TextField
                                      name={`dataArr[${index}].number`}
                                      disabled={values?.isView}
                                      value={number}
                                      onChange={(e) => handleNumberChange(e, handleChange, setFieldValue)}
                                      size='small'
                                      fullWidth
                                    />
                                  </TableCell>
                                  <TableCell >
                                    <DirectorySelect
                                      sx={{ width: "200px" }}
                                      name={`dataArr[${index}].workType`}
                                      disabled={values?.isView}
                                      value={workType}
                                      onChange={v => setFieldValue(`dataArr[${index}].workType`, v)}
                                      hideLabel={true}
                                      fullWidth
                                      dirName="activities"
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <TextField
                                      name={`dataArr[${index}].scope`}
                                      disabled={values?.isView}
                                      value={scope}
                                      onChange={handleChange}
                                      size='small'
                                      fullWidth
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <DatePicker
                                      name={`dataArr[${index}].start`}
                                      disabled={values?.isView}
                                      value={start}
                                      onChange={v => setFieldValue(`dataArr[${index}].start`, v?.valueOf())}
                                      size='small'
                                      fullWidth
                                      variant="outlined"
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <DatePicker
                                      name={`dataArr[${index}].end`}
                                      disabled={values?.isView}
                                      value={end}
                                      onChange={v => setFieldValue(`dataArr[${index}].end`, v?.valueOf())}
                                      size='small'
                                      fullWidth
                                      variant="outlined"
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <TextField
                                      name={`dataArr[${index}].processRequirements`}
                                      disabled={values?.isView}
                                      value={processRequirements}
                                      onChange={handleChange}
                                      size='small'
                                      fullWidth
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <TextField
                                      name={`dataArr[${index}].resultRequirements`}
                                      disabled={values?.isView}
                                      value={resultRequirements}
                                      onChange={handleChange}
                                      size='small'
                                      fullWidth
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    {values?.isView ?
                                      (!!rights?.['order-create'] ? (
                                        <Button
                                          color="primary"
                                          variant="contained"
                                          disabled={![5,6].includes(values?.rawStatus)}
                                          onClick={() => createWorkOrder(plan, workType)}
                                        >
                                          Создать З&#8209;Н
                                        </Button>
                                      ) : null
                                      ) : (

                                        <Button
                                          color="error"
                                          variant="contained"
                                          disabled={values?.isView}
                                          onClick={() => remove(index)}
                                        >
                                          Удалить
                                        </Button>
                                      )
                                    }
                                  </TableCell>
                                </TableRow>
                              )
                            })
                          ) : null}
                          {values?.isView ? null : (
                            <TableFooter>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right">
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    disabled={values?.isView}
                                    onClick={() => push({
                                      // id,
                                      number: '',
                                      workType: undefined,
                                      scope: '',
                                      start: new Date().valueOf(),
                                      end: new Date().valueOf(),
                                      processRequirements: '',
                                      resultRequirements: '',
                                    })}
                                  >
                                    Добавить
                                  </Button>
                                </TableCell>
                              </TableRow>
                            </TableFooter>
                          )}
                        </TableContainer>


                      </>
                    )}
                  />
                </div>
                <SaveStatus dataObj={addingDocument} postSuccessAction={postSaveAction} errShowTime={1000} successShowTime={100} />
                <SaveStatus dataObj={savingDocument} postSuccessAction={postSaveAction} errShowTime={1000} successShowTime={100} />
                <Button color="primary" variant="contained" type="submit" disabled={ro}>
                  Сохранить
                </Button>
                <Button color="primary" variant="outlined" onClick={onCancel}>
                  Отмена
                </Button>
              </form>
            )}
          </Formik>
        </div>
      </div >
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>

        </div>
        {/* <BodyRight /> */}
      </div>

    </div >
  );
};

export default memo(DocumentSheduleEditor);